import { Layout } from "@/components/layout/Layout";
import {
  LoadI18nMessagesProps,
  loadIntlMessages,
} from "@/utils/loadIntlMessages";
import { getStrapiEntity } from "@/utils/strapi";
import { routes } from "@/routes/routes";
import { queryLicenseFree } from "@/strapiQuery/licenseFree";
import { VehicleType } from "@/components/common/searchBlock/children/vehicleTypeSelection/VehicleTypeSelection";
import { LicenseFreeContent } from "@/components/pages/licenseFree/LicenseFree";
import { ReviewsConst } from "@/components/common/reviewsBlock/ReviewsBlock";
import { queryReviewsConst } from "@/strapiQuery/queryReviewsConst";

export const getStaticProps = async (ctx: LoadI18nMessagesProps) => {
  const layoutPromise = getStrapiEntity<Layout>("layout", "");
  const reviewsConst = await getStrapiEntity<ReviewsConst>(
    "reviews-const",
    queryReviewsConst
  );

  const licenseFreeContentPromise = getStrapiEntity<LicenseFreeContent>(
    "license-free-truck",
    queryLicenseFree
  );

  const [layout, licenseFreeContent] = await Promise.all([
    layoutPromise,
    licenseFreeContentPromise,
  ]);

  const intlMessages = loadIntlMessages(ctx);

  return {
    props: {
      layout,
      reviewsConst,
      ...licenseFreeContent,
      vehicleType: VehicleType.TRUCK,
      intlMessages,
      defaultCanonicalRoute: routes.licenseFreeTruck,
    },
    revalidate: 10,
  };
};

export { LicenseFree as default } from "@/components/pages/licenseFree/LicenseFree";
